import { type FunctionalComponent, h } from '@stencil/core';

interface ISvsTooltip {
  text: string;
}

export const SvsTooltip: FunctionalComponent<ISvsTooltip> = (props) => {
    return (
      <div class="svs-tooltip">
        <section class="svs-tooltip__content">
          {props.text}
        </section>
        <div class="svs-tooltip__triangle" />
      </div>
    );
};
